export default __webpack_public_path__ + "static/media/values.e09a58ca.png";